import { FC } from "react";

export const Maintenance: FC = () => <p>Maintenance in progress</p>;
